var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueRightThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.12668 0.0695457C0.846545 0.210214 0.730489 0.563787 0.874559 0.822312C0.910576 0.886944 2.3873 2.4343 4.15216 4.26299C5.91702 6.08788 7.44576 7.68086 7.54581 7.79871L7.7339 8.01542L7.63786 8.12947C7.58983 8.1903 6.06109 9.77188 4.2442 11.65C2.42732 13.5243 0.922582 15.0945 0.894569 15.1401C0.734491 15.4214 0.838541 15.7902 1.11868 15.9233C1.35079 16.0373 1.51887 16.0259 1.73898 15.8777C1.83903 15.813 3.46382 14.163 5.34874 12.2203C7.23766 10.2737 8.85445 8.60471 8.9505 8.50966C9.18661 8.26634 9.23864 8.07245 9.13859 7.80632C9.07456 7.62763 8.69437 7.22083 5.49281 3.92462C3.53185 1.90204 1.83903 0.187403 1.73898 0.118969C1.52688 -0.0216999 1.33879 -0.0369072 1.12668 0.0695457Z",
    fill: "#34A9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRightThin);
export default __webpack_public_path__ + "static/media/blue-right-thin.31300d230342b56d6e54b844143afe70.svg";
export { ForwardRef as ReactComponent };